import '../../styles/Clinician.css'
import { Link, useLocation } from "react-router-dom"
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from "../../auth";
import { Roles } from '../../data_layer/repositories/Users/UserRoles'
import { TimeOutHandler } from "../IdleTimeOutHandler/TimeOutHandler";
import { MillisOnMinute, isTimeoutActive } from "../../utilities/Constants";
import { ProfileDropdown } from "./ProfileDropdown";

import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { PatientDropdown } from '../Cards/PatientFullDetailsCardComponents/PatientDropdown';
import { PatientContext } from '../../data_layer/context/Patient/PatientContext';
import { useGetPatientList } from '../CustomHooks/useGetPatientList';

export const ClinicianNavbar = ({
    setSearch,
    setSort
}) => {

    const { 
        patients,
        showFavorites, 
        changeShowFavorites,
        showDetails,
        changeShowDetails,
        showGraph,
        changeShowGraph
    } = useContext(PatientContext);

    const { 
        logout, 
        user, 
        facility
    } = useContext(AuthContext);

    const { patients: patientList } = useGetPatientList();

    const [isActive, setIsActive] = useState(true);
    const [isLogout, setIsLogout] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const { pathname } = useLocation();

    function onSearchChange({ target }) {
        setSearchValue(target.value);
        setSearch(target.value);
    }

    function onSelectSortChanged({ target }) {
        setSort(target.value);
    }

    function handleShowDetailsChanged() {
        changeShowDetails();
    }

    function handleShowChartChanged() {
        changeShowGraph();
    }

    // function handleShowSavedChanged() {
    //     setShowSaved(!showSaved);
    // }


    return (

        <div className="navbar navbar-expand-lg navbar-light bg-light bg-white py-2 px-4 d-flex ">
            {
                isTimeoutActive && <TimeOutHandler
                    onActive={() => { setIsActive(true) }}
                    onIdle={() => { setIsActive(false) }}
                    onLogout={() => {
                        setIsLogout(true);
                        logout();
                    }}
                    timeOutInterval={facility.web_timeout_session * MillisOnMinute} />
            }
            <div className="d-flex w-100  align-items-center justify-content-between">
                <div className="d-flex align-items-center me-5">
                    <Link to="/" className='navbar-brand neo_nav_brand'>
                        <img
                            src={require('../../assets/Neoneuro-FF.png')}
                            alt="Neoneur Logo"
                        />
                    </Link>
                    <div className="ms-5">
                        <p className="m-0 fw-bold">{facility.name}</p>
                    </div>
                </div>

                {!pathname.includes('patients') &&
                    <div className="d-flex">
                        <div className="d-flex">
                            <div className="rounded-4 align-items-center p-2 d-flex border border-2 border-dark w-100">
                                <input type="text" name="" id="" className="d-flex input-wh-style w-100"
                                    placeholder="Search patient"
                                    onChange={onSearchChange}
                                    value={searchValue} />
                                <i className='bx bx-search text-xl ms-auto'></i>
                            </div>
                            <div className="ms-2">
                                <select className="rounded-4 border border-2 border-dark p-2 h-100 neo_select"
                                    name=""
                                    id=""
                                    onChange={onSelectSortChanged}>
                                    <option value="most-recent" defaultValue={true}>Most Recent</option>
                                    <option value="a-z" >A-Z</option>
                                    <option value="z-a" >Z-A</option>
                                    <option value="id" >ID</option>
                                </select>
                            </div>
                        </div>

                        <div className="d-flex align-items-center ms-auto">
                            <div className="mx-2">
                                <div className="d-flex align-items-center form-check form-switch">
                                    <label className="form-check-label fw-semibold" htmlFor="flexSwitchCheckDefault">Show sessions details</label>
                                    <input
                                        className="form-check-input ms-3"
                                        type="checkbox"
                                        role="switch"
                                        id="flexSwitchCheckDefault"
                                        checked={showDetails}
                                        onChange={handleShowDetailsChanged} />
                                </div>
                            </div>
                            <div className="me-2">
                                <div className="d-flex align-items-center form-check form-switch">
                                    <label className="form-check-label fw-semibold" htmlFor="flexSwitchCheckDefault2">Show graph</label>
                                    <input
                                        className="form-check-input ms-3"
                                        type="checkbox"
                                        role="switch"
                                        id="flexSwitchCheckDefault2"
                                        checked={showGraph}
                                        onChange={handleShowChartChanged} />
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center form-check form-switch">
                                    <label className="form-check-label fw-semibold" htmlFor="flexSwitchCheckDefault3">Show saved</label>
                                    <input
                                        className="form-check-input ms-3"
                                        type="checkbox"
                                        role="switch"
                                        id="flexSwitchCheckDefault3"
                                        checked={showFavorites}
                                        onChange={changeShowFavorites} />
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {pathname.includes('patients') &&
                    <div className="d-flex align-items-stretch align-items-center">
                        <div className="w-55">
                            <div className="d-flex neo_select rounded-4 border border-2 border-dark p-2 h-100 w-100 align-items-center">
                                <span>{`ID: ${patients[0]?.patient?.ehr_patient_ref}`}</span>
                            </div>
                        </div>
                        {
                            [...patients, {}].slice(0, 3)
                                .map((patient, index) => (
                                    index > 0 &&
                                    <div className='d-flex align-items-stretch align-items-center' key={`patient-select-${index}`}>
                                        <div className='ms-2 mt-2'>
                                            <FaArrowRightArrowLeft />
                                        </div>
                                        <div className="w-55 ms-2 ">
                                            <PatientDropdown options={patientList.sort((a,b) => a.ehr_patient_ref.localeCompare(b.ehr_patient_ref))} selectedOption={index > 0 ? patient : {}} />
                                        </div>
                                    </div>
                                ))
                        }

                    </div>
                }

                <div className="ms-auto d-flex align-items-center">
                    <ProfileDropdown className="text-3xl text-color mx-5" user={user} facility={facility} logout={logout} />
                </div>
            </div>
        </div>
    )
}